<template>
  <div class="device-case-detail">
    <DetailTable></DetailTable>
  </div>
</template>

<script>
import DetailTable from "@/components/DetailTable"
export default {
  name: "DeviceCaseDetail",
  components: {
    DetailTable
  },
  data () {
    return {
      list: []
    }
  },
  mounted () {
  }
};
</script>

<style lang="less" scoped>

</style>